// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__zjijX","label":"LabeledBox_label__3idRZ"};